import React from 'react';
import { useParams, Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Cockpit from './Pages/cockpit';
import MyPages from './Pages';
import MyGastro from './Gastro';
import MyExternals from './Externals';
import Error404 from './Pages/404';
import ErrorISustav from './Pages/error-isustav';
import Login from './Auth/Login';
import PasswordChange from './Auth/PasswordChange';
import LoginMilenij from './Auth/LoginMilenij';
import LoginMilenij2 from './Auth/LoginMilenij2';
import Help from './Help';
import Register from './Auth/Register';
import RegisterTravel from './Auth/RegisterTravel';
import ForgotPasswordPage from './Auth/ForgotPassword';
import ShiftPlanner from './Pages/shiftplanner';
import SelfCheckIn from './Pages/selfcheckin';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { authUser } = useSelector(({ auth }) => auth);

  return (
    <Route
      {...rest}
      render={props =>
        authUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();
  const selectedProperty = localStorage.getItem('selectedProperty');
  console.log(location.pathname);
  if (authUser) console.log(authUser.role);

  if (authUser && authUser.masterAccount === 1) {
    if (authUser.selectedProperty === 0 || selectedProperty == null || selectedProperty == '')
      if (location.pathname != '/pages/selectproperty') return <Redirect to={'/pages/selectproperty'} />;
    if (authUser.selectedProperty != 0 || (selectedProperty != null && selectedProperty != ''))
      if (location.pathname == '/pages/selectproperty') return <Redirect to={'/pages/cockpit-wbp'} />;
  }

  if (authUser && localStorage.getItem('expiredPassword') == 'true' && location.pathname != '/passwordChange') {
    return <Redirect to={'/passwordChange'} />;
  } else if (authUser && authUser.clouduser == 1 && authUser.hotels.length == 0 && location.pathname != '/error-iSustav') {
    return <Redirect to={'/error-iSustav'} />;
  } else if (location.pathname === '' || location.pathname === '/') {
    if (window.location.hostname === 'app.milenij.hr') return <Redirect to={'/mobile'} />;
    else if (window.location.hostname === 'gastro.milenij.hr') return <Redirect to={'/gastromobile'} />;
    else return <Redirect to={'/signin'} />;
  } else if (
    authUser &&
    (location.pathname === '/signin' ||
      location.pathname === '/forgot-password' ||
      location.pathname === '/mobile' ||
      location.pathname === '/gastromobile') /*||
      location.pathname === '/passwordChange'*/
  ) {
    if (authUser.bookingengine == 0 && authUser.apptasks == 1) return <Redirect to={'/admin/mod_tasks'} />;
    else if (authUser.bookingengine == 0 && authUser.vcenabled == 1) return <Redirect to={'/admin/mod_vc'} />;
    else if (authUser.clouduser == 0 && authUser.role == 20) return <Redirect to={'/pages/bookings'} />;
    else if (authUser.clouduser == 0 && authUser.role == 19) return <Redirect to={'/pages/dashboard'} />;
    else if (authUser.clouduser == 0 && authUser.role == 13) return <Redirect to={'/pages/bookings'} />;
    else if (authUser.clouduser == 0 && authUser.role == 10) return <Redirect to={'/pages/cockpit-wbp'} />;
    else if (authUser.clouduser == 0 && authUser.role == 18) return <Redirect to={'/pages/cockpit-wbp'} />;
    else if (authUser.clouduser == 0 && authUser.role == 16) return <Redirect to={'/pages/bookings'} />;
    else if (authUser.clouduser == 0 && authUser.role == 17) return <Redirect to={'/pages/cockpit-wbp'} />;
    else if (authUser.clouduser == 0 && authUser.role == 11) return <Redirect to={'/pages/cockpit-wbp'} />;
    else if (authUser.clouduser == 0 && authUser.role == 12) return <Redirect to={'/pages/cockpit-wbp'} />;
    else if (authUser.clouduser == 0 && authUser.role == 5) return <Redirect to={'/pages/arrivals'} />;
    else if (authUser.clouduser == 1 && (authUser.features & 1) != 0) return <Redirect to={'/pages/cockpit'} />;
    else if (authUser.clouduser == 1 && (authUser.features & 2) != 0) return <Redirect to={'/pages/timeline'} />;
    else if (authUser.clouduser == 1 && (authUser.features & 4) != 0) return <Redirect to={'/pages/arrivals'} />;
    else if (authUser.clouduser == 2) return <Redirect to={'/gastro/homepage'} />;
    else if (authUser.role == 10) return <Redirect to={'/pages/timeline'} />;
    else if (authUser.role == 14) return <Redirect to={'/admin/hotels_info'} />;
    else if (authUser.role == 5) return <Redirect to={'/pages/activity-today'} />;
    //  else if (authUser && location.pathname === '/signin') {
    //return <Redirect to={'/sample-page'} />;
  }

  return (
    <React.Fragment>
      <Switch>
        {authUser != null && authUser.clouduser == 1 && <RestrictedRoute path="/cockpit" component={Cockpit} />}
        <Route path="/pages/shiftplanner" component={ShiftPlanner} />
        <Route path="/pages/selfcheckin/:hotelCode/:hotelId/:bookingId" component={SelfCheckIn} />
        <Route path="/pages/selfcheckin/:hotelCode/:hotelId" component={SelfCheckIn} />
        <Route path="/pages/selfcheckin/wbp/:hotelId/:bookingId" component={SelfCheckIn} />
        <Route path="/pages/selfcheckin/wbp/:hotelId" component={SelfCheckIn} />

        <RestrictedRoute path="/pages/" component={MyPages} />
        <RestrictedRoute path="/gastro/" component={MyGastro} />
        <RestrictedRoute path="/admin/" component={MyExternals} />
        <Route path="/error-iSustav" component={ErrorISustav} />
        <Route path="/signin" component={Login} />
        <Route path="/passwordChange" component={PasswordChange} />
        <Route path="/mobile" component={LoginMilenij} />
        <Route path="/gastromobile" component={LoginMilenij2} />
        <Route path="/help" component={Help} />
        <Route path="/signup" component={Register} />
        <Route path="/signuptravel" component={RegisterTravel} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
